import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { api } from '@/api/client';
import type { CreateSupplierRequest, UpdateSupplierRequest } from '@/api/inventory';
import type { Supplier } from '@/api/types';

export function useSuppliers() {
  return useQuery({
    queryKey: ['suppliers'],
    queryFn: () => api.get<Supplier[]>('/api/suppliers'),
    staleTime: 30_000,
  });
}

export function useCreateSupplier() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (request: CreateSupplierRequest) => api.post<Supplier>('/api/suppliers', request),
    onSuccess: () => void queryClient.invalidateQueries({ queryKey: ['suppliers'] }),
  });
}

export function useUpdateSupplier() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, request }: { id: string; request: UpdateSupplierRequest }) =>
      api.put<Supplier>(`/api/suppliers/${id}`, request),
    onSuccess: () => void queryClient.invalidateQueries({ queryKey: ['suppliers'] }),
  });
}

export function useDeleteSupplier() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => api.delete<void>(`/api/suppliers/${id}`),
    onSuccess: () => void queryClient.invalidateQueries({ queryKey: ['suppliers'] }),
  });
}
